export default __webpack_public_path__ + "static/O0056-5507bf8f397d8f1e976284febd480b0d.png";